export default "__VITE_ASSET__CUlvh_hC__"